import { pxToRem } from './utils/pxToRem';

export const Typographies = {
  h1Large: {
    fontFamily: 'ReplicaPro, sans-serif',
    fontSize: pxToRem(48),
    fontFamilyNative: 'ReplicaPro-Heavy',
    lineHeight: pxToRem(55),
    fontWeight: '700',
    letterSpacing: '0',
  },
  h1: {
    fontFamily: 'ReplicaPro, sans-serif',
    fontFamilyNative: 'ReplicaPro-Heavy',
    fontSize: pxToRem(32),
    lineHeight: pxToRem(35),
    fontWeight: '700',
    letterSpacing: '0',
  },
  h2: {
    fontFamily: 'ReplicaPro, sans-serif',
    fontFamilyNative: 'ReplicaPro-Bold',
    fontSize: pxToRem(28),
    lineHeight: pxToRem(31),
    fontWeight: 'bold',
    letterSpacing: '0',
  },
  h3: {
    fontFamily: 'ReplicaPro, sans-serif',
    fontFamilyNative: 'ReplicaPro-Regular',
    fontSize: pxToRem(22),
    lineHeight: pxToRem(25),
    fontWeight: 'normal',
    letterSpacing: '0',
  },
  h4: {
    fontFamily: 'ReplicaPro, sans-serif',
    fontFamilyNative: 'ReplicaPro-Regular',
    fontSize: pxToRem(18),
    lineHeight: 'normal',
    fontWeight: 'normal',
    letterSpacing: '0',
  },
  large: {
    fontFamily: 'ReplicaPro, sans-serif',
    fontFamilyNative: 'ReplicaPro-Regular',
    fontSize: pxToRem(18),
    lineHeight: 'normal',
    fontWeight: 'normal',
    letterSpacing: '0',
  },
  base: {
    fontFamily: 'ReplicaPro, sans-serif',
    fontFamilyNative: 'ReplicaPro-Light',
    fontSize: pxToRem(16),
    lineHeight: '2rem',
    fontWeight: 'lighter',
    letterSpacing: '0',
  },
  small: {
    fontFamily: 'ReplicaPro, sans-serif',
    fontFamilyNative: 'ReplicaPro-Regular',
    fontSize: pxToRem(14),
    lineHeight: 'normal',
    fontWeight: 'normal',
    letterSpacing: '0',
  },
  light: 'ReplicaPro-Light',
  regular: 'ReplicaPro-Regular',
  bold: 'ReplicaPro-Bold',
  heavy: 'ReplicaPro-Heavy',
};
